<template>
  <div class="bip">
    <navBar v-if="navigationbar" :text="$t('index.nav')"></navBar>
    <div class="bar_box" :class="navigationbar ? 'bar_box_active' : ''">
      <div class="bip_bar_box" v-if="headbar">
        <div
          class="bip_bar"
          :class="selectbar == 1 ? 'bip_bar_active' : ''"
          @click="bar(1)"
        >
          <div class="bip_bar_text">{{ $t("index.game") }}</div>
          <div class="bip_bar_tiao"></div>
        </div>
        <!-- <div
          class="bip_bar"
          :class="selectbar == 2 ? 'bip_bar_active' : ''"
          @click="bar(2)"
        >
          <div class="bip_bar_text">{{ $t("index.welfare") }}</div>
          <div class="bip_bar_tiao"></div>
        </div> -->
        <div
          class="bip_bar"
          :class="selectbar == 3 ? 'bip_bar_active' : ''"
          @click="bar(3)"
        >
          <div class="bip_bar_text">{{ $t("index.category") }}</div>
          <div class="bip_bar_tiao"></div>
        </div>
      </div>
    </div>

    <div class="ios_box" v-if="boxshow">
      <div class="hint" v-if="hintloading">
        <div class="hint_loading_box">
          <img class="hint_loading" src="@/img/gif2.gif" alt="" />
        </div>
      </div>

      <!-- 这是最近玩的模块 -->
      <!-- <div class="ios_lists Recently" v-if="isPlayList.length > 0"> -->
      <div
        v-if="selectbar == 1"
        :class="navigationbar ? 'seek_box_top_active' : ''"
      >
        <div
          :class="headbar ? 'ios_lists top' : 'ios_lists Recently'"
          v-if="getIosRecentPlayList().length > 0"
        >
          <div class="ios_title">{{ $t("iosIndex.history_title") }}</div>
          <div class="ios_list">
            <div v-for="(item, index) in getIosRecentPlayList()">
              <div class="ios_game" @click="onPlay(item)" :key="index">
                <div class="ios_game_left">
                  <div class="ios_game_url">
                    <img
                      class="ios_game_img imgs"
                      :src="item.imageSrc"
                      alt=""
                    />
                  </div>
                  <div class="ios_game_centent">
                    <div class="ios_game_title">{{ item.name }}</div>
                    <div class="ios_game_players">
                      {{ formateNumber(item.totalPlayer) }}
                      {{ $t("index.player") }}
                    </div>
                  </div>
                </div>
                <div class="ios_game_btn">
                  <img
                    class="ios_game_btn_img"
                    :src="imgList[getTheme].btnImg"
                    alt=""
                  />
                </div>
              </div>

              <div
                class="page_ad"
                v-if="index === 2"
                id="adx-home-top-container"
                style="display: none"
              >
                <p class="page_ad_title">{{ $t("index.ad") }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="ios_lists" v-if="GameList.length > 0">
          <div class="ios_title">{{ $t("iosIndex.allgame") }}</div>
          <div class="ios_list">
            <div
              v-for="(item, index) in GameList[GameList.length - 1].gameList"
            >
              <div class="ios_game" @click="onPlay(item)">
                <div class="ios_game_left">
                  <div class="ios_game_url">
                    <img
                      class="ios_game_img imgs"
                      :src="item.imageSrc"
                      alt=""
                    />
                  </div>
                  <div class="ios_game_centent">
                    <div class="ios_game_title">{{ item.name }}</div>
                    <div class="ios_game_players">
                      {{ formateNumber(item.totalPlayer) }}
                      {{ $t("index.player") }}
                    </div>
                  </div>
                </div>
                <div class="ios_game_btn">
                  <img
                    class="ios_game_btn_img"
                    :src="imgList[getTheme].btnImg"
                    alt=""
                  />
                </div>
              </div>
              <div
                class="page_ad"
                v-if="index === 2 - getIosRecentPlayList().length"
                id="adx-home-top-container"
                style="display: none"
              >
                <p class="page_ad_title">{{ $t("index.ad") }}</p>
              </div>
              <div
                class="page_ad"
                v-if="
                  index === GameList[GameList.length - 1].gameList.length - 1
                "
                id="adx-home-bottom-container"
                style="display: none"
              >
                <p class="page_ad_title">{{ $t("index.ad") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectbar == 3 && headbar" style="height: 100%">
        <Category></Category>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
import Category from "@/components/category";
import navBar from "@/components/nav/navBarIndex";

export default {
  components: {
    Category,
    navBar,
  },
  data() {
    return {
      headbar: true,

      // 判断是哪个页面
      selectbar: 1,
      hintloading: false,
      getTheme: "",
      boxshow: false,
      imgList: {
        khalaspay: {
          btnImg: require("@/img/regular.png"),
        },
        dark: {
          btnImg: require("@/img/dark.png"),
        },
        lavender: {
          btnImg: require("@/img/lavender.png"),
        },
        orange: {
          btnImg: require("@/img/orange.png"),
        },
        "night-blue": {
          btnImg: require("@/img/night-blue.png"),
        },
        regular: {
          btnImg: require("@/img/regular.png"),
        },
      },
      // 导航后退
      navigationbar: false,
    };
  },
  computed: {
    ...mapGetters("game", ["getIosRecentPlayList", "isPlayList"]),
    ...mapState("game", ["GameList"]),
  },
  created() {
    this.GetGameList();
    this.getTheme = configs.getTheme();
    // 判断是否在bridge中
    if (window.TgaBridge) {
      this.headbar = false;
    }
    if (window.Bridge) {
      this.headbar = false;
    }
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      this.headbar = false;
    }

    const navigationbar =
      configs.GetQueryString("navigationbar") ||
      this.$route.query.navigationbar;
    if (navigationbar && navigationbar == "true") {
      this.navigationbar = true;
    }
  },
  mounted() {
    var self = this;
    window.addEventListener("pagehide", function () {
      self.hintloading = false;
    });
  },
  updated: function () {
    if (!window.pageAdLoaded) {
      window.pageAdLoaded = true;

      tgaPlatformSDK.ad.showPageAd("home-top");
      tgaPlatformSDK.ad.showPageAd("home-bottom");
    }
  },
  methods: {
    ...mapActions("game", [
      "ActionGameList",
      "ActionGameIdList",
      "changeRecentPlayList",
      "gamePlay",
    ]),
    formateNumber(data) {
      return configs.formateNumber(data);
    },
    async onPlay(item) {
      var self = this;
      // 点击去玩就添加数据到缓存
      var time = new Date().getTime();
      localStorage.setItem("ShareGame", JSON.stringify(item));
      localStorage.setItem("Sharetime", JSON.stringify(time));
      this.hintloading = true;
      this.clearpaly = setTimeout(function () {
        self.hintloading = false;
      }, 600000);
      this.changeRecentPlayList({
        $axios: this.$axios,
        recentPlay: item,
        userId: "",
      });
      // 新版统计
      window.dataKule.push("track", "game", "play-btn", {
        id: item.gameId,
      });
      await this.gamePlay({
        $axios: this.$axios,
        $router: this.$router,
        url: item.playUrl,
        ImageSrc: item.imageSrc,
        $root: this.$root,
      });
    },
    // 获取游戏的列表
    async GetGameList() {
      var self = this;
      // self.isEnd =false
      let lang = localStorage.getItem("lang");
      // const res = await this.ActionGameList({
      //   $axios: this.$axios,
      //   lang: lang
      // });

      // 判断是否有
      if (!localStorage.getItem("BIPGameList")) {
        const res = await this.ActionGameList({
          $axios: this.$axios,
          lang: lang,
        });
      } else {
        const res = await this.ActionGameIdList({
          $axios: this.$axios,
          lang: lang,
        });
        if (res == false) {
          const res = await this.ActionGameList({
            $axios: this.$axios,
            lang: lang,
          });
        }
      }
      this.boxshow = true;
      // self.isEnd = true;
    },
    bar(index) {
      if (localStorage.getItem("txn_id")) {
        this.selectbar = index;
      } else {
        if (index == 2) {
          this.openAppLogin({
            $axios: this.$axios,
            status: true,
          });
        }
      }
    },
  },
};
</script>

<style scoped="scoped">
.ios_box {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background-color: var(--iosBackground);
  /* padding: 0.58rem 0.6rem; */
  font-family: "MuseoSans";
  font-weight: 500;
}

.ios_title {
  text-align: center;
  font-size: 0.52rem;
  color: var(--iosTitle);
  margin-bottom: 0.26rem;
  font-family: "MuseoSans";
  font-weight: 900;
}

.ios_lists {
  background-color: var(--iosBackground);
  padding-bottom: 0.9rem;
}

.top {
  padding-top: 1.32rem;
}

.ios_list {
  margin-top: 0.18rem;
}

.ios_game {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.28rem;
  /* border: 1px solid #ddd; */
  border-radius: 0.2rem;
  background-color: var(--iosGameBackground);
  padding: 0.3rem 0.46rem;
  box-shadow: var(--iosGameBoxShadow);
}

.ios_game_left {
  display: flex;
}

.ios_game_url {
  width: 1.94rem;
  height: 1.94rem;
  border-radius: 0.63rem;
}

.ios_game_img {
  width: 1.94rem;
  height: 1.94rem;
  border-radius: 0.63rem;
}

.ios_game_centent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.49rem;
}

.ios_game_title {
  font-size: 0.49rem;
  color: var(--iosGameTitle);
  font-family: MuseoSans;
  font-weight: 500;
}

.ios_game_players {
  margin-top: 0.1rem;
  font-size: 0.38rem;
  color: rgb(142, 142, 149);
}

.ios_game_btn {
  width: 0.87rem;
  height: 0.87rem;
}

.ios_game_btn_img {
  width: 0.87rem;
  height: 0.87rem;
}

.Recently {
  /* margin-bottom: 0.5rem; */
}

/* 提示语 */
.hint {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.hint_loading_box {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hint_loading {
  width: 3rem;
  height: 3rem;
  opacity: 0.8;
}

@media screen and (min-width: 1000px) {
  .bar_box,
  .seek {
    max-width: 800px !important;
    margin: 0 auto !important;
  }
}

@media screen and (min-width: 1000px) {
  .bar_box {
    width: 800px !important;
    left: unset !important;
  }
}

.bip {
  width: 100%;
  height: 100%;
}

.bar_box {
  width: 100%;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
}

.bar_box_active {
  top: 1.5rem;
}

.bip_bar_box {
  height: 1.2rem;
  width: 100%;
  display: flex;
  background-color: var(--bg);
}

.bip_bar {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* position: relative; */
}

.bip_bar_tiao {
  height: 0.07rem;
  margin-top: 0.2rem;
  /* position: absolute; */
  /* bottom: 0.1rem; */
  /* left: calc((100% - 0.71rem) / 2); */
}

.bip_bar_text {
  font-size: 0.42rem;
  color: var(--titleColor);
  font-weight: bold;
}

.bip_bar_active .bip_bar_tiao {
  width: 0.71rem;
  height: 0.07rem;
  background-color: var(--titleTiao);
  border-radius: 0.03rem;
}

.bip_bar_active .bip_bar_text {
  color: var(--titleColorActive);
  font-size: 0.42rem;
  font-weight: bold;
}
.seek_box_top_active {
  margin-top: 1.6rem;
}
.page_ad {
  width: 100%;
}
.page_ad_title {
  text-align: center;
  font-size: 0.3rem;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/iosIndex.vue